// js/components/client-links/index.js

import template from './index.pug'

export default Vue.extend({
  name: 'client-links-custom-cg',
  template: template(),
  created(){
    console.log("Client links loaded")
  }
})
